import { ref, watch } from 'vue'
import type { Ref } from 'vue'
export function usePostechTableFilter(tableData: Ref<Array<any>>, searchArr: Array<any>) {
  // const allData = ref(JSON.parse(JSON.stringify(tableData)));
  const allData = tableData.value

  const filtered = ref(tableData.value)
  const search = ref(searchArr)
  //this is failing on customer field, as some of them are null
  watch(
    () => search.value,
    (newVal, oldVal) => {
      //console.log("watch called on searchArr.value = " + JSON.stringify(newVal));
      //let lowercase = newVal.map(text=>{
      //  return text.toString().toLowerCase();
      //});
      filtered.value = allData.filter((row) => {
        //console.log("..row = " + JSON.stringify(row));
        const postechId = newVal['id'].toString().toLowerCase();
        const projectId = newVal['projectId'].toString().toLowerCase();
        const pileCount = newVal['pileCount'].toString().toLowerCase();
        const installer = newVal['installer'].toString().toLowerCase();
     
        const invoiceNameRow = row['installer']
        //const emailRow = row['email'];
        return (
          row['id'].toString().toLowerCase().includes(postechId) &&
          row['projectId'].toString().toLowerCase().includes(projectId) &&
          row['pileCount'].toString().toLowerCase().includes(pileCount) &&
          (invoiceNameRow != null
            ? invoiceNameRow.toString().toLowerCase().includes(installer)
            : true)
          //(emailRow!=null ? emailRow.toString().toLowerCase().includes(searchEmail) : true);// &&
          //row['projectCount'].toString().toLowerCase().includes(searchJobCount)
        )
        //(row['owner'] ? row['owner'].toString().toLowerCase().includes(owner) : false); // &&
        // row['customerName'].toString().toLowerCase().includes(customer) &&
        //rowCust ? rowCust.name.toString().toLowerCase().includes(customer) : false;
        //row.customer.name.toString().toLowerCase().includes(customer) &&
      })
      //filtered.value = props.tableData.filter(row => row[props.columnName].toString().toLowerCase().includes(newVal.toLowerCase()));
    },
    { deep: true }
  )

  return { filtered }
}
